import { createAction, props } from '@ngrx/store';
import { EntityKey } from '@feature/pma-document-centre/pma-document-centre-types';
import { ITable } from '@common/models/table';

const tag = '[Arrears Listing]';

export const loadArrearsTable = createAction(
  `${tag} Load Arrears`,
  props<{
    key?: EntityKey,
    dashboardWidgetId?: number;
    viewName?: string;
  }>()
);



export const loadArrearsTableComplete = createAction(
  `${tag} Load Arrears Complete`,
  props<{
    dashboardWidgetId: number,
    table: ITable;
  }>()
);

export const loadArrearsTenantTableComplete = createAction(
  `${tag} Load Arrears Tenant Complete`,
  props<{
    dashboardWidgetId: number,
    table: ITable;
  }>()
);

export const loadArrearsTableError = createAction(
  `${tag} Load Arrears Error`,
  props<{ error: any }>()
);
